import { render, staticRenderFns } from "./Informacion.vue?vue&type=template&id=3fadb1e4&scoped=true"
import script from "./Informacion.vue?vue&type=script&lang=js"
export * from "./Informacion.vue?vue&type=script&lang=js"
import style0 from "./Informacion.vue?vue&type=style&index=0&id=3fadb1e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fadb1e4",
  null
  
)

export default component.exports